export const coreUrls = {
  customerDisplaySettingsURL: 'core/customerDisplaySettings',
}
